<template>
  <div class="base-form-popup" @mouseover="showPopup = true" @mouseout="hidePopup">
    <span>
      <img src="@/assets/img/orders/info-icon.svg" />
    </span>
    <span class="base-form-popuptext" :class="{'show': showPopup}">
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    text: { type: String, default: "" }
  },
  data() {
    return {
      showPopup: false
    }
  },
  methods: {
    hidePopup() {
      this.showPopup = false
    }
  }
}
</script>

<style>
.base-form-popup {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.base-form-popup .base-form-popuptext {
  visibility: hidden;
  font-size: 12px;
  width: 280px;
  background-color: #eaeaea;
  color: #8d8d8d;
  text-align: center;
  padding: 12px;
  position: absolute;
  z-index: 100;
  bottom: 95%;
  left: 50%;
  margin-left: -50px;
}

.base-form-popup .base-form-popuptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 18%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #eaeaea transparent transparent transparent;
}

.base-form-popup .show {
  visibility: visible;
  -webkit-animation: fadeIn 0.5s;
  animation: fadeIn 0.5s;
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
